import type { PurchasedProduct } from "@/hooks/usePurchasedProducts";
import type { PurchasedProductDetail } from "@/hooks/usePurchasedProductDetail";
import type { ManageSubscriptionSheetProduct } from "./types";

export function purchasedProductToManageSheet(
  p: PurchasedProduct,
): ManageSubscriptionSheetProduct | null {
  if (p.shopify_subscription_id == null) return null;
  return {
    id: p.id,
    quantity: p.quantity,
    title: p.title,
    image_url: p.image_url,
    variant_title: p.variant_title ?? undefined,
    shopify_subscription_id: p.shopify_subscription_id,
    subscription_status: p.subscription_status ?? null,
    subscription_next_billing_date: p.subscription_next_billing_date ?? null,
    subscription_last_charge_date: p.subscription_last_charge_date ?? null,
    subscription_paused_until: p.subscription_paused_until ?? null,
    paused_until: p.paused_until ?? null,
    subscription_order_count: p.subscription_order_count ?? null,
    can_skip_next_order: p.can_skip_next_order ?? null,
    subscription_max_reschedule_date:
      p.subscription_max_reschedule_date ?? null,
    price: p.price,
    price_after_discount: p.price_after_discount ?? null,
    order_line_item_price: p.order_line_item_price ?? null,
    subscription_unit_price: p.subscription_unit_price ?? null,
    subscription_one_time_price: p.subscription_one_time_price ?? null,
    subscription_discounted_price: p.subscription_discounted_price ?? null,
    subscription_discounts: p.subscription_discounts ?? null,
    subscription_billing_interval: p.subscription_billing_interval ?? null,
    subscription_billing_interval_count:
      p.subscription_billing_interval_count ?? null,
    subscription_shipping_price: p.subscription_shipping_price ?? null,
    subscription_cancellation_requested_at:
      p.subscription_cancellation_requested_at ?? null,
    subscription_swap_requested_at: p.subscription_swap_requested_at ?? null,
    subscription_conversion_fee_paid:
      p.subscription_conversion_fee_paid ?? null,
    subscription_cancel_scheduled_at:
      p.subscription_cancel_scheduled_at ?? null,
    subscription_is_flexible: p.subscription_is_flexible ?? null,
  };
}

export function purchasedProductDetailToManageSheet(
  p: PurchasedProductDetail,
): ManageSubscriptionSheetProduct | null {
  if (p.shopify_subscription_id == null) return null;
  const variant =
    p.variants.find((v) => v.shopify_id === p.variant_id) ?? p.variants[0];
  return {
    id: p.id,
    title: p.title,
    image_url: p.image_url,
    variant_title: variant?.title ?? null,
    shopify_subscription_id: p.shopify_subscription_id,
    subscription_status: p.subscription_status ?? null,
    subscription_next_billing_date: p.subscription_next_billing_date ?? null,
    subscription_last_charge_date: p.subscription_last_charge_date ?? null,
    subscription_paused_until: p.subscription_paused_until ?? null,
    paused_until: p.paused_until ?? null,
    subscription_order_count: p.subscription_order_count ?? null,
    can_skip_next_order: p.can_skip_next_order ?? null,
    subscription_max_reschedule_date:
      p.subscription_max_reschedule_date ?? null,
    price: p.price,
    price_after_discount: p.price_after_discount ?? null,
    order_line_item_price: p.order_line_item_price ?? null,
    subscription_unit_price: p.subscription_unit_price ?? null,
    subscription_one_time_price: p.subscription_one_time_price ?? null,
    subscription_discounted_price: p.subscription_discounted_price ?? null,
    subscription_discounts: p.subscription_discounts ?? null,
    subscription_billing_interval: p.subscription_billing_interval ?? null,
    subscription_billing_interval_count:
      p.subscription_billing_interval_count ?? null,
    subscription_cancellation_requested_at:
      p.subscription_cancellation_requested_at ?? null,
    subscription_swap_requested_at: p.subscription_swap_requested_at ?? null,
    subscription_conversion_fee_paid:
      p.subscription_conversion_fee_paid ?? null,
    subscription_cancel_scheduled_at:
      p.subscription_cancel_scheduled_at ?? null,
    subscription_is_flexible: p.subscription_is_flexible ?? null,
  };
}
